import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_redbull-redesign/artifacts/ltmi545z_Gemini_Generated_Image_593rn7593rn7593r.png';

const BullLogo = ({ size = 48, className = '', rounded = true }) => {
  return (
    <img
      src={LOGO_URL}
      alt="La Bodega Logo"
      style={{ height: size, width: 'auto' }}
      className={`object-contain ${rounded ? 'rounded-lg' : ''} ${className}`}
    />
  );
};

export default BullLogo;
